import Vue from 'vue';
import Vuetify from 'vuetify/lib';

// Registered once here; main.js builds the instance with TrustClap's light theme.
Vue.use(Vuetify);

export default Vuetify;
